import { TypeKeys, ActionTypes } from '../actions/index';
import { getEmptyLanguageKeys } from '../global/translate';

const getInitialState = (): SworkitState['challengeBanner'] => {
  return {
    active: [],
    challengeOptions: [],
    id: null,
    showJoinChallengeBanner: null,
    challengeStartDate: null,
    hideJoinChallengeBanner: null,
    backgroundImageUrl: null,
    title: getEmptyLanguageKeys(),
    description: getEmptyLanguageKeys(),
    learnMoreUrl: null,
  };
};

const activeChallenge = (
  state = getInitialState(),
  action: ActionTypes
): SworkitState['challengeBanner'] => {
  switch (action.type) {
    case TypeKeys.SET_ACTIVE_CHALLENGE_BANNER: {
      if (action.challengeBanner) {
        return action.challengeBanner;
      } else {
        return getInitialState();
      }
    }
    case TypeKeys.SIGN_OUT: {
      return getInitialState();
    }
  }
  return state;
};

export default activeChallenge;
